import React from 'react';

const CategoryTicketDisplay = ({ booking, ticket }) => {
  const renderCategoryDetails = () => {
    if (!booking.categorySpecificData) return null;

    const data = booking.categorySpecificData;
    
    switch (ticket.category) {
      case 'parking_ticket':
        return (
          <div style={{
            background: '#f0f9ff',
            padding: '16px',
            borderRadius: '8px',
            marginBottom: '16px',
            border: '1px solid #0ea5e9'
          }}>
            <h4 style={{ margin: '0 0 12px 0', color: '#0369a1', display: 'flex', alignItems: 'center', gap: '8px' }}>
              🅿️ Parking Details
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', fontSize: '14px' }}>
              <div>
                <strong>Vehicle Type:</strong> {data.vehicleType?.toUpperCase()}
              </div>
              <div>
                <strong>Vehicle Number:</strong> {data.vehicleNumber?.toUpperCase()}
              </div>
            </div>
            <div style={{ marginTop: '12px', padding: '8px', background: '#dbeafe', borderRadius: '4px', fontSize: '12px' }}>
              💡 Present this ticket and vehicle documents at the parking entrance
            </div>
          </div>
        );

      case 'chappal_stand_ticket':
        return (
          <div style={{
            background: '#fef3c7',
            padding: '16px',
            borderRadius: '8px',
            marginBottom: '16px',
            border: '1px solid #f59e0b'
          }}>
            <h4 style={{ margin: '0 0 12px 0', color: '#92400e', display: 'flex', alignItems: 'center', gap: '8px' }}>
              👟 Chappal Stand Service
            </h4>
            <div style={{ fontSize: '14px', marginBottom: '8px' }}>
              <strong>Number of Pairs:</strong> {data.pairCount || 1}
            </div>
            {data.instructions && (
              <div style={{ fontSize: '14px', marginBottom: '8px' }}>
                <strong>Instructions:</strong> {data.instructions}
              </div>
            )}
            <div style={{ marginTop: '12px', padding: '8px', background: '#fde68a', borderRadius: '4px', fontSize: '12px' }}>
              💡 You will receive numbered tokens - keep them safe for collection
            </div>
          </div>
        );

      case 'puja_ticket':
        const selectedServices = data.selectedServices || {};
        const hasServices = Object.entries(selectedServices).some(([_, qty]) => qty > 0);
        

        
        return (
          <div style={{
            background: '#fdf2f8',
            padding: '16px',
            borderRadius: '8px',
            marginBottom: '16px',
            border: '1px solid #ec4899'
          }}>
            <h4 style={{ margin: '0 0 12px 0', color: '#be185d', display: 'flex', alignItems: 'center', gap: '8px' }}>
              🙏 Puja Service Details
            </h4>
            
            {hasServices ? (
              <div style={{ marginBottom: '12px' }}>
                <div style={{ fontWeight: '600', marginBottom: '8px', color: '#be185d' }}>Selected Services:</div>
                {data.totalAmount > 0 && (
                  <div style={{ 
                    background: 'linear-gradient(45deg, #be185d, #ec4899)',
                    color: 'white',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontWeight: '600',
                    marginBottom: '12px',
                    textAlign: 'center'
                  }}>
                    Total Service Amount: ₹{data.totalAmount}
                  </div>
                )}
                <div style={{ display: 'grid', gap: '6px' }}>
                  {Object.entries(selectedServices)
                    .filter(([_, quantity]) => quantity > 0)
                    .map(([serviceName, quantity]) => {
                      const servicePrice = ticket.pujaServices?.[serviceName]?.price || data.servicePrices?.[serviceName] || 0;

                      return (
                        <div key={serviceName} style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          background: '#fce7f3',
                          padding: '8px 12px',
                          borderRadius: '6px',
                          fontSize: '14px'
                        }}>
                          <span style={{ fontWeight: '500' }}>{serviceName}</span>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ background: '#be185d', color: 'white', padding: '2px 8px', borderRadius: '12px', fontSize: '12px' }}>
                              Qty: {quantity}
                            </span>
                            <span style={{ fontWeight: '600', color: '#be185d' }}>₹{servicePrice * quantity}</span>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            ) : (
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '12px' }}>
                No specific services selected
              </div>
            )}
            
            {data.preferredTime && (
              <div style={{ fontSize: '14px', marginBottom: '12px' }}>
                <strong>Preferred Time:</strong> {data.preferredTime.charAt(0).toUpperCase() + data.preferredTime.slice(1)}
              </div>
            )}
            
            <div style={{ marginTop: '12px', padding: '8px', background: '#fce7f3', borderRadius: '4px', fontSize: '12px' }}>
              🕯️ Please arrive 15 minutes early and maintain silence during the ceremony
            </div>
            
            <div style={{
              background: '#f8fafc',
              padding: '12px',
              borderRadius: '6px',
              marginTop: '12px',
              border: '1px solid #e2e8f0'
            }}>
              <h5 style={{ margin: '0 0 8px 0', color: '#374151', fontSize: '14px' }}>📋 Important Instructions</h5>
              <ul style={{ margin: 0, paddingLeft: '16px', fontSize: '12px', lineHeight: '1.5' }}>
                <li>🙏 Arrive 15 minutes before your preferred time</li>
                <li>🌸 Bring flowers and offerings if desired</li>
                <li>📿 Maintain silence and respect during the ceremony</li>
                <li>📱 Photography may be restricted during puja</li>
              </ul>
            </div>
          </div>
        );

      case 'function_hall_ticket':
        const selectedAmenities = data.selectedAmenities || {};
        const hasAmenities = Object.entries(selectedAmenities).some(([_, qty]) => qty > 0);
        
        return (
          <div style={{
            background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
            padding: '20px',
            borderRadius: '12px',
            marginBottom: '16px',
            border: '2px solid #f59e0b',
            boxShadow: '0 4px 12px rgba(245, 158, 11, 0.2)'
          }}>
            <h4 style={{ 
              margin: '0 0 16px 0', 
              color: '#92400e', 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px',
              fontSize: '18px',
              fontWeight: '700'
            }}>
              🏛️ Function Hall Booking Details
            </h4>
            
            {/* Hall Information */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.8)',
              padding: '16px',
              borderRadius: '8px',
              marginBottom: '16px',
              border: '1px solid rgba(245, 158, 11, 0.3)'
            }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '12px', fontSize: '14px' }}>
                <div><strong>Hall Capacity:</strong> {ticket.functionHallSettings?.hallCapacity || 100} people</div>
                <div><strong>Duration:</strong> {ticket.functionHallSettings?.duration || 4} hours</div>
                <div><strong>Base Price:</strong> ₹{ticket.price}</div>
              </div>
              {data.eventType && (
                <div style={{ marginTop: '12px', fontSize: '14px' }}>
                  <strong>Event Type:</strong> {data.eventType.charAt(0).toUpperCase() + data.eventType.slice(1)}
                </div>
              )}
              {data.expectedGuests && (
                <div style={{ marginTop: '8px', fontSize: '14px' }}>
                  <strong>Expected Guests:</strong> {data.expectedGuests} people
                </div>
              )}
            </div>
            
            {/* Selected Services */}
            {hasAmenities && (
              <div style={{ marginBottom: '16px' }}>
                <div style={{ fontWeight: '700', marginBottom: '12px', color: '#92400e', fontSize: '16px' }}>🛠️ Selected Services:</div>
                <div style={{ display: 'grid', gap: '8px' }}>
                  {Object.entries(selectedAmenities)
                    .filter(([_, quantity]) => quantity > 0)
                    .map(([amenityName, quantity]) => {
                      const amenityPrice = ticket.functionHallSettings?.amenities?.[amenityName]?.price || 0;
                      return (
                        <div key={amenityName} style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          background: 'rgba(255, 255, 255, 0.9)',
                          padding: '12px 16px',
                          borderRadius: '8px',
                          fontSize: '14px',
                          border: '1px solid rgba(245, 158, 11, 0.2)'
                        }}>
                          <span style={{ fontWeight: '600', textTransform: 'capitalize' }}>
                            {amenityName.replace(/_/g, ' ')}
                          </span>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <span style={{ 
                              background: '#f59e0b', 
                              color: 'white', 
                              padding: '4px 12px', 
                              borderRadius: '16px', 
                              fontSize: '12px',
                              fontWeight: '600'
                            }}>
                              Qty: {quantity}
                            </span>
                            <span style={{ fontWeight: '700', color: '#92400e', fontSize: '16px' }}>₹{amenityPrice * quantity}</span>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
                
                {/* Total Amount Display */}
                <div style={{
                  background: 'linear-gradient(45deg, #f59e0b, #d97706)',
                  color: 'white',
                  padding: '16px',
                  borderRadius: '8px',
                  marginTop: '16px',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '18px', fontWeight: '700', marginBottom: '4px' }}>Total Amount: ₹{data.totalAmount || booking.totalAmount}</div>
                  <div style={{ fontSize: '12px', opacity: 0.9 }}>Hall Booking + Selected Services</div>
                </div>
              </div>
            )}
            
            {/* Special Requirements */}
            {data.specialRequirements && (
              <div style={{
                background: 'rgba(255, 255, 255, 0.8)',
                padding: '12px',
                borderRadius: '8px',
                marginBottom: '16px',
                border: '1px solid rgba(245, 158, 11, 0.3)'
              }}>
                <div style={{ fontWeight: '600', marginBottom: '8px', color: '#92400e' }}>📝 Special Requirements:</div>
                <div style={{ fontSize: '14px', lineHeight: '1.5' }}>{data.specialRequirements}</div>
              </div>
            )}
            
            {/* Important Instructions */}
            <div style={{
              background: 'rgba(239, 68, 68, 0.1)',
              padding: '16px',
              borderRadius: '8px',
              border: '1px solid rgba(239, 68, 68, 0.2)'
            }}>
              <h5 style={{ margin: '0 0 12px 0', color: '#dc2626', fontSize: '14px', fontWeight: '700' }}>⚠️ Important Instructions</h5>
              <ul style={{ margin: 0, paddingLeft: '16px', fontSize: '12px', lineHeight: '1.6', color: '#374151' }}>
                <li>🕐 Hall will be available from your booked time slot</li>
                <li>🧹 Please maintain cleanliness and return hall in good condition</li>
                <li>🔊 Sound system usage subject to local noise regulations</li>
                <li>🚫 Smoking and alcohol consumption as per hall policy</li>
                <li>💰 Any damages will be charged separately</li>
                <li>📞 Contact hall management for any additional requirements</li>
              </ul>
            </div>
          </div>
        );

      case 'event_ticket':
        return (
          <div style={{
            background: '#f0fdf4',
            padding: '16px',
            borderRadius: '8px',
            marginBottom: '16px',
            border: '1px solid #22c55e'
          }}>
            <h4 style={{ margin: '0 0 12px 0', color: '#15803d', display: 'flex', alignItems: 'center', gap: '8px' }}>
              🎭 Event Details
            </h4>
            <div style={{ fontSize: '14px' }}>
              {data.seatingPreference && (
                <div style={{ marginBottom: '8px' }}>
                  <strong>Seating:</strong> {data.seatingPreference.charAt(0).toUpperCase() + data.seatingPreference.slice(1)} Section
                </div>
              )}
              {data.specialRequirements && (
                <div style={{ marginBottom: '8px' }}>
                  <strong>Special Requirements:</strong> {data.specialRequirements}
                </div>
              )}
            </div>
            <div style={{ marginTop: '12px', padding: '8px', background: '#dcfce7', borderRadius: '4px', fontSize: '12px' }}>
              🎪 Arrive 30 minutes early for the best experience
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  const renderInstructions = () => {
    if (!booking.categoryInstructions || booking.categoryInstructions.length === 0 || ticket.category === 'puja_ticket') return null;

    return (
      <div style={{
        background: '#f8fafc',
        padding: '16px',
        borderRadius: '8px',
        marginTop: '16px',
        border: '1px solid #e2e8f0'
      }}>
        <h4 style={{ margin: '0 0 12px 0', color: '#374151' }}>📋 Important Instructions</h4>
        <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px', lineHeight: '1.6' }}>
          {booking.categoryInstructions.map((instruction, index) => (
            <li key={index} style={{ marginBottom: '4px' }}>
              {instruction}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div>
      {renderCategoryDetails()}
      {renderInstructions()}
    </div>
  );
};

export default CategoryTicketDisplay;